/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Body from 'DesignSystem/Body/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Account/Content/UpdateNotice/Content",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtColorsGreen700alpha83 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.83'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bbc-1-Z1Yf8zk': dtColorsGreen700,'--bc-2-Z1Yf8zk': dtColorsGreen700alpha83}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal1}`}
>
<Body
  viewPath={`${viewPath}/Body`}
 color="#f5f5f5"
 text="New version available. Click here to update."
/>
</button>
</div>
{children}
</React.Fragment>)
}